import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { filterProps } from 'helpers/utils'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'

const CartItem = ({
  children
}) =>
  <Table>
    <Media.Desktop>
      <Row>
        <Head data-at-quote-tbl-product>Product Detail</Head>
        <Head data-at-quote-tbl-quantity quantity>Quantity</Head>
        <Head data-at-quote-tbl-unitprice left unitPrice>Unit Price</Head>
        <Head data-at-quote-tbl-totalprice right totalPrice>Total Price</Head>
      </Row>
    </Media.Desktop>
    { children }
  </Table>

CartItem.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element)
}

export default CartItem

const Table = styled.div`
  position: relative;
  ${Media.desktop`
    display: table;
    table-layout: fixed;
    width: 100%;
  `}
  ${Media.mobile`
    padding: 20px 10px;
  `}
`

const Row = styled.div`
  ${Media.desktop`
    display: table-row;
  `}
`

const propsToRemove = [
  'definedWidth',
  'quantity',
  'unitPrice',
  'totalPrice',
  'width',
  'right',
  'left'
]

const Head = styled(props => <div { ...filterProps(props, propsToRemove) } />)`
  display: table-cell;
  font-weight: 600;
  padding: 10px 0;
  color: ${Theme.colors.white};
  background-color: ${Theme.colors.dark_grey};
  ${props => props.width && css`
    ${Media.desktop`
      width: 165px;
    `}
  `}
  ${props => props.quantity && css`
    ${Media.desktop`
      width: 150px;
    `}
    ${Media.tablet`
      width: 110px;
    `}
  `}
  ${props => props.unitPrice && css`
    ${Media.desktop`
      width: 120px;
    `}
    ${Media.tablet`
      width: 95px;
    `}
  `}
  ${props => props.totalPrice && css`
    ${Media.desktop`
      width: 120px;
    `}
  `}
  ${props => props.right && css`
    text-align: right;
  `}
  ${props => props.left && css`
    text-align: left;
  `}

  &:first-child {
    padding: 10px 20px;
  }

  &:last-child {
    padding-right: 20px;
  }
`
